import { useEffect } from 'react'
import useBriefContext from '../../../../Hooks/Brief/useBriefContext'
import useStateTransition from '../../../../Hooks/useStateTransition'
import isDirectEnquiryBrief from '../../../../Logic/Form/Sequences/DirectEnquiry/isDirectEnquiryBrief'
import MessagingAside from './Aside'
import MessagingModal from './Modal'

const LeadFeedMessaging = (): JSX.Element | null => {
  const { brief, showBizLayout: willShowBizLayout } = useBriefContext()
  const isDirectEnquiry = isDirectEnquiryBrief(brief)
  const [{ state: showBizLayout }, setShowBizLayout] = useStateTransition(willShowBizLayout, 1000)

  useEffect(() => {
    if (willShowBizLayout === showBizLayout) return

    setShowBizLayout(willShowBizLayout)
  }, [willShowBizLayout])

  if (showBizLayout) return null

  return (
    <>
      <MessagingAside isDirectEnquiry={isDirectEnquiry} triggerFadeOut={willShowBizLayout} />
      <MessagingModal isDirectEnquiry={isDirectEnquiry} triggerFadeOut={willShowBizLayout} />
    </>
  )
}

export default LeadFeedMessaging
